import PermissionContextProvider from "./context/PermissionContextProvider";
import PermissionsWrapped from "./components/PermissionsWrapped";

const Permissions = () => (
  <PermissionContextProvider>
    <PermissionsWrapped />
  </PermissionContextProvider>
)

export default Permissions